<template>
  <div>
    <cbs-html-sandbox
      v-if="page"
      :page="page"
      :context="sandboxContext"
      :min-height="300"
      @action="onAction"
      @setvalue="onSetValue"
    />
    <div
      v-else-if="loadError"
      class="text-muted p-1"
    >{{ loadError }}</div>
    <div
      v-else
      class="d-flex justify-content-center p-3"
    >
      <b-spinner />
    </div>
    <cbs-debug
      v-if="false"
      :context="this"
    />
  </div>
</template>

<script>
import { BSpinner } from 'bootstrap-vue'
import CbsDebug from '@/cubus/components/debug/CbsDebug.vue'
import CbsHtmlSandbox from '@/cubus/components/html-sandbox/CbsHtmlSandbox.vue'
import { loadHtmlPage } from '@/cubus/html-sandbox/htmlPageApi'

export default {
  name: 'CbsCustomHtmlForm',
  components: {
    CbsHtmlSandbox,
    CbsDebug,
    BSpinner,
  },
  props: {
    objectFull: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      page: null,
      loadError: null,
    }
  },
  computed: {
    pageSid() {
      if (!this.objectFull || !this.objectFull.params || !this.objectFull.params.params) return null
      const prm = this.objectFull.params.params.find(p => p.paramname === 'htmlpage')
      return prm ? prm.paramvalue : null
    },
    sandboxContext() {
      const obj = this.objectFull ? this.objectFull.object : null
      return {
        mode: 'form',
        form: {
          objectid: obj ? obj.id : null,
          objectsid: obj ? obj.sid : null,
          objectname: obj ? obj.name : null,
          params: this.objectFull ? this.objectFull.params : null,
        },
      }
    },
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      if (!this.pageSid) {
        this.loadError = 'Параметр htmlpage не задан у объекта (нужен вместе с customform=html).'
        return
      }
      loadHtmlPage(this.pageSid)
        .then(page => { this.page = page })
        .catch(err => { this.loadError = err.message || String(err) })
    },
    onAction(name, data) {
      this.$emit('action', name, data)
    },
    onSetValue(attribute, value) {
      // Объектная форма не редактирует одиночную запись; прокидываем наверх,
      // чтобы будущие рекорд-хосты могли применить значение.
      this.$emit('setvalue', attribute, value)
    },
  },
}
</script>

<style scoped>

</style>
